import { enums } from './controls/enums.js'
import { Methods } from './observer/methods.js'
import { mainWorker } from './main.js'
import { Basic } from './controls/basic.js'
import { MSPopUpWindow } from './controls/popup_window/popup_window.js'
import { MSTap } from './controls/tap/tap.js'
import { MSToggleButton } from './controls/togglebutton/togglebutton.js'
import { MSDateTimePicker } from './controls/dtpicker/dtpicker.js'
import { GlobalParameters } from 'generated'
import { MSDataTree } from './controls/tree/tree.js'
import { MSFrame } from './controls/frame/frame.js'
import { MSBimFrame } from './controls/bimframe/bimframe.js'
import { MSWindow } from './controls/window/window.js'
import Formating from './lib/formating.js'
import { MSChart } from './controls/chart/chart.js'
import { MSChartColumn } from './controls/chartcolumn/chartcolumn.js'
import { MSCheckBox } from './controls/checkbox/checkbox.js'
import { MSClock } from './controls/clock/clock.js'
import { MSColorPicker } from './controls/colorpicker/colorpicker.js'
import { MSComboBox } from './controls/combobox/combobox.js'
import { MSDataTable } from './controls/datatable/datatable.js'
import { MSDictionary } from './controls/dictionary/dictionary.js'
import { MSGauge } from './controls/gauge/gauge.js'
import { MSGauge1 } from './controls/gauge/gauge1.js'
import { MSPolygon } from './controls/polygon/polygon.js'
import { MSInterval } from './controls/interval/interval.js'
import { MSJournal } from './controls/journal/journal.js'
import { MSLegend } from './controls/legend/legend.js'
import { MSLine } from './controls/line/line.js'
import { MSMap } from './controls/map/map.js'
import { MSMark } from './controls/mark/mark.js'
import { MSMessageIndicator } from './controls/messageindicator/messageindicator.js'
import { MSNumericUpDown } from './controls/numericupdown/numericupdown.js'
import { MSOval } from './controls/oval/oval.js'
import { MSPanelCanvas } from './controls/panelcanvas/panelcanvas.js'
import { MSPanelStack } from './controls/panelstack/panelstack.js'
import { MSPanelTab } from './controls/paneltab/paneltab.js'
import { MSPanelTabControl } from './controls/paneltabcontrol/paneltabcontrol.js'
import { MSPassInput } from './controls/passinput/passinput.js'
import { MSPlayHistory } from './controls/playhistory/playhistory.js'
import { MSProgressBar } from './controls/progressbar/progressbar.js'
import { MSRadioButton } from './controls/radiobutton/radiobutton.js'
import { MSRange } from './controls/range/range.js'
import { MSRect } from './controls/rect/rect.js'
import { MSRTSPCamera } from './controls/rtspcamera/rtspcamera.js'
import { MSSlider } from './controls/slider/slider.js'
import { MSSvg } from './controls/svg/svg.js'
import { MSTextInput } from './controls/textinput/textinput.js'
import { MSText } from './controls/text/text.js'
import { MSTrend } from './controls/trend/trend.js'
import { MSTrendDiscrete } from './controls/trend/trendiscrete.js'
import { MSUploadFile } from './controls/uploadfile/uploadfile.js'
import { MSVideo } from './controls/video/video.js'
import { MSCalendarInput } from './controls/calendarinput/calendarinput.js'
window.customElements.define('ms-chart', MSChart);
window.customElements.define('ms-chartcolumn', MSChartColumn);
window.customElements.define('ms-checkbox', MSCheckBox);
window.customElements.define('ms-clock', MSClock);
window.customElements.define('ms-colorpicker', MSColorPicker);
window.customElements.define('ms-combobox', MSComboBox);
window.customElements.define('ms-datatable', MSDataTable);
window.customElements.define('ms-dictionary', MSDictionary);
window.customElements.define('ms-gauge', MSGauge);
window.customElements.define('ms-gauge1', MSGauge1);
window.customElements.define('ms-polygon', MSPolygon);
window.customElements.define('ms-interval', MSInterval);
window.customElements.define('ms-journal', MSJournal);
window.customElements.define('ms-legend', MSLegend);
window.customElements.define('ms-line', MSLine);
window.customElements.define('ms-map', MSMap);
window.customElements.define('ms-mark', MSMark);
window.customElements.define('ms-messageindicator', MSMessageIndicator);
window.customElements.define('ms-numericupdown', MSNumericUpDown);
window.customElements.define('ms-oval', MSOval);
window.customElements.define('ms-pcanvas', MSPanelCanvas);
window.customElements.define('ms-pstack', MSPanelStack);
window.customElements.define('ms-tab', MSPanelTab);
window.customElements.define('ms-ptab', MSPanelTabControl);
window.customElements.define('ms-passinput', MSPassInput);
window.customElements.define('ms-playhistory', MSPlayHistory);
window.customElements.define('ms-progress', MSProgressBar);
window.customElements.define('ms-radiobutton', MSRadioButton);
window.customElements.define('ms-range', MSRange);
window.customElements.define('ms-rect', MSRect);
window.customElements.define('ms-rtspcamera', MSRTSPCamera);
window.customElements.define('ms-slider', MSSlider);
window.customElements.define('ms-svg', MSSvg);
window.customElements.define('ms-textinput', MSTextInput);
window.customElements.define('ms-text', MSText);
window.customElements.define('ms-trend', MSTrend);
window.customElements.define('ms-trendds', MSTrendDiscrete);
window.customElements.define('ms-uploadfile', MSUploadFile);
window.customElements.define('ms-video', MSVideo);
window.customElements.define('ms-calendarinput', MSCalendarInput);


window._enums = new enums();
window._globalParams = GlobalParameters.globals;
window._globalParams.location = { hostname: window._globalParams.MainIP, port: window._globalParams.WebPort };
window._methods = new Methods(window._globalParams.RequestServerPrefix);
const formating = new Formating();
window.customElements.define('ms-popup', MSPopUpWindow);
window.customElements.define('ms-togglebutton', MSToggleButton);
window.customElements.define('ms-dtpicker', MSDateTimePicker);
window.customElements.define('ms-image', Basic);
window.customElements.define('ms-tree', MSDataTree);
const main = new mainWorker();
window.customElements.define('ms-tap', MSTap);
window.customElements.define('ms-frame', MSFrame);
window.customElements.define('ms-bimframe', MSBimFrame);
window.customElements.define('ms-window', MSWindow);
